'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { BsArrowLeft } from 'react-icons/bs';
import ListingGrid from '@/features/global-search-banner/components/listing-grid/listing-grid';
import SearchPlace from '@/features/place/components/search-place/search-place';
import { type Place } from '@/features/place/types/place-types';
import Button from '@/ui/button/button';
import styles from './search-slider.module.scss';
interface SearchSliderProps {
  place: Place | null;
  lastSearchedPlaces: Place[] | null;
  showServiceType: boolean;
  setShowServiceType: (value: boolean) => void;
}
export default function SearchSlider(props) {
  const $ = _c(22);
  const {
    lastSearchedPlaces,
    place,
    setShowServiceType,
    showServiceType
  } = props;
  let t0;
  if ($[0] !== setShowServiceType) {
    t0 = () => {
      setShowServiceType(true);
    };
    $[0] = setShowServiceType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const moveServiceTypeStage = t0;
  let t1;
  if ($[2] !== setShowServiceType) {
    t1 = () => {
      setShowServiceType(false);
    };
    $[2] = setShowServiceType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const backToSearchStage = t1;
  const t2 = showServiceType && styles.searchSlider_container__left;
  let t3;
  if ($[4] !== t2) {
    t3 = cx(styles.searchSlider_container, t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== lastSearchedPlaces || $[7] !== moveServiceTypeStage || $[8] !== place) {
    t4 = <div className={styles.searchSlider_search}><SearchPlace currentPlace={place} lastSearchedPlaces={lastSearchedPlaces} isNeedMoveForwardButton={true} moveForwardButtonCallback={moveServiceTypeStage} isMainPage={true} /></div>;
    $[6] = lastSearchedPlaces;
    $[7] = moveServiceTypeStage;
    $[8] = place;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BsArrowLeft />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== backToSearchStage) {
    t6 = <Button className={styles.searchSlider_backToSearch} name="back" aria-label="back" onClick={backToSearchStage} type="button" element="button" shade="light" size="lg" variant="ghost">{t5}</Button>;
    $[11] = backToSearchStage;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ListingGrid />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6) {
    t8 = <div className={styles.searchSlider_listingTypes}>{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t8) {
    t9 = <div className={styles.searchSlider_content}>{t4}{t8}</div>;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t3 || $[20] !== t9) {
    t10 = <div className={styles.searchSlider}><div className={t3}>{t9}</div></div>;
    $[19] = t3;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}